import HeroTemplate from '../heroTemplate/heroTemplate';
import styles from '../../styles/main.module.scss';
import Content404 from './content404/content404';
import Bg404 from './404.gif';

export default function Custom404() {
  const data = {
    hero: {
      title: null,
      headline: '',
      theme: 'white',
      affectCreditScore: null,
      config: {
        gradientMask: null,
      },
      cta: null,
      heroDesc: null,
      heroWhiteCopyBg: '',
      image: {
        alt: '404',
        src: Bg404.src,
      },
      logos: [],
      prequal: '',
      socialProof: [],
      subHeroText: null,
      tiles: 'none',
    },
    content404: {
      headline: 'Uh Oh.',
      subTitle: 'Sorry, the page you’re looking for isn’t here.',
      description:
        '<p>You may have followed a broken link, or we may have moved or renamed the page. Visit our homepage, or <a href="mailto:website@lendingclub.com?subject=website error">contact us</a> about the problem.</p>',
      cta: {
        label: 'Go to Homepage',
        link: '/',
      },
      theme: null,
    },
  };

  return (
    <main className={styles.main}>
      <div className={styles.landingPage}>
        <div className={styles.components}>
          <HeroTemplate {...data.hero} />
          <div className={styles.container}>
            <div className={styles.section}>
              <Content404 {...data.content404} />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
